import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { of } from 'rxjs';
import { IoniconsOutline } from '@pt/pt-models';
import { WidgetDialogService } from '../../../services';

@Component({
  selector: 'pt-widget-text-v0-autosave',
  template: `
    <ng-container *ngIf="loading; then LOADING; else PREVIEW"></ng-container>

    <ng-template #LOADING>
      Loading ...
    </ng-template>

    <ng-template #PREVIEW>

      <ng-container *ngIf="!!note && note?.length > 0; then DATA; else NODATA"></ng-container>

      <ng-template #NODATA>
        <pt-widget-nodata [showEditBtn]="true"
                          [disableEditBtn]="disabled"
                          (click)="openDialog(note)"
                          [noDataLabel]="noDataLabel">
        </pt-widget-nodata>
      </ng-template>

      <ng-template #DATA>

        <div class="d-flex flex-column">
          <span *ngIf="disabled"
                class='pt-widget-text-autosave-v0 text-gray-700'
                [innerHTML]="htmlValue">
          </span>

          <span *ngIf="!disabled"
                (click)="openDialog(note)"
                container="body"
                ngbTooltip='{{"LABELS.EDIT" | translate}}'
                class='pt-widget-text-autosave-v0 active'
                [innerHTML]="htmlValue">
          </span>

        </div>


      </ng-template>
    </ng-template>
  `,
  styles: [`
    .pt-widget-text-autosave-v0 {
      width: 100%;
      background: none;
      padding: 8px;
      overflow-y: auto;
      color: #000;
      height: 75px;
      border: 1px solid #cccccc;
    }
    .pt-widget-text-autosave-v0.active {
      cursor: pointer;
    }
    .pt-widget-text-autosave-v0.active:hover {
      background: #D6E4FF;
    }
  `]
})
export class WidgetTextV0AutosaveComponent implements OnChanges {
  @Input() note: string;
  @Input() label: string;
  @Input() loading: boolean;
  @Input() noDataLabel?: string;
  @Input() disabled = true;
  @Output() changeNoteAndSave = new EventEmitter<string>();
  @Output() closeDialogWithoutSave = new EventEmitter<boolean>();
  IconEdit = IoniconsOutline.edit;

  htmlValue: string;

  constructor(private widgetDialogService: WidgetDialogService) {
  }

  ngOnChanges(): void {
    this.htmlValue = this.note ? this.note.split('\n').join('<br />') : '';
  }

  openDialog(note: string) {
    if (!this.disabled) {
      const dialog = this.widgetDialogService.runTextArea(
        of(this.label),
        note,
        true
      );
      dialog.subscribe((value) => {
        if (this.note !== value) {
          this.note = value;
          this.changeNoteAndSave.emit(this.note);
        } else {
          this.closeDialogWithoutSave.emit();
        }
      }, () => {
        this.closeDialogWithoutSave.emit();
      });
    }

  }
}
